// extracted by mini-css-extract-plugin
module.exports = {"container":"e_vh","icon":"e_wh","pathBg":"e_xh","pathFg":"e_yh","variantViolet":"e_zh","variantBase":"e_Ah"};